import {
  IonButton,
  IonCol,
  IonGrid,
  IonImg,
  IonLabel,
  IonModal,
  IonRow,
} from "@ionic/react";
import { loadAssignedData } from "../../../actions/carrierAssign/action";
import {
  CityError,
  MODULES,
  MY_LOAD,
  ALERT_BUTTON_ROLES,
  EGPSTrackingStatus
} from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Persona } from "../persona/persona";
import "./ConfirmStartTrip.scss";
import { LoadStop } from "../loadStops/loadStops";
import { StartTripModel } from "../../../models/home/StartTrip.model";
import { InTransitModel } from "../../../models/home/InTransit.model";
import { confirmStartInformation } from "../../../actions/myload/action";
import { useHistory } from "react-router";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import { NewInput } from "../common/OriginInput";
import { setNavigation } from "../../../actions/App/action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { checkDriverUnassignStatus } from "../../../components/app/ShipmentUpdateScreen/ShipmentUpdate.Util";
import { Alert } from "../../../components/Alert/Alert";
import i18n from "../../../../i18n";
import { removeDriverUnassignedLoad } from "../../../actions/DriverAssign/action";
import { dayjs } from "../../../utils/Date/DateUtil";

export interface IConfirmStartTripProps {
  open: boolean;
  userDetails: any;
  loadDetails: any;
  onDismiss: () => void;
  loadData: any;
  calculateTime: (stop: any) => string;
  count: any;
  GPSTrackingStatus: any;
}

export const ConfirmStartTrip: React.FunctionComponent<IConfirmStartTripProps> = (
  props: IConfirmStartTripProps
) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    loadDetails = {},
    open,
    onDismiss,
    userDetails = {},
    loadData = {},
    GPSTrackingStatus,
  } = props;

  let loadStops: any[] = (loadDetails?.loadStop) || [];
  loadStops =
    loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  const loadStopsToShow: any[] = [];

  loadStops.forEach((load: any, index: number) => {
    if (index == 0 || index == loadStops.length - 1) {
      loadStopsToShow.push(load);
    }
  });

  const driverName =
    props.loadDetails?.assignmentTransaction &&
    props.loadDetails.assignmentTransaction[0] &&
    props.loadDetails.assignmentTransaction[0].driverName;
  const startTripModel: StartTripModel = new StartTripModel();
  const [isError, setisError] = useState(false);
  const [originError, setoriginError] = useState("");
  const [locationName, setLocationName] = useState("");
  const [ActualStart, setActualStart] = useState<string>(
    startTripModel.getCurrentTimeInISO()
  );
  const [country, setCountry] = useState("");
  const [isCurrentLocationAvailable, setCurrentLocationStatus] = useState<
    boolean
  >(false);
  const [timezone, settimezone] = useState("");
  const [lat, setlat] = useState("");
  const [lng, setlng] = useState("");
  const [showUnassignedMessage, updateShowUnassignedMessage] = useState<
    boolean
  >(false);

  const cityError = CityError;
  const setErrorValue = (value: boolean, name: string) => {
    setisError(value);
    if (name === "locationName" && value === true) {
      setoriginError(cityError);
    } else if (name === "locationName" && value === false) {
      setoriginError("");
    }
  };
  const handleChangeEvent = (event: any) => {
    {
      if (
        event.target.name === "locationName" &&
        event.target.value.length > 0
      ) {
        setoriginError("");
      }
      if (isCurrentLocationAvailable) {
        setLocationName(event.target.value);
        setlat(event.target.lat);
        setlng(event.target.lng);
        setCountry(event.target.country);
      } else {
        setLocationName(event.target.value);
        setlat(event.target.lat);
        setlng(event.target.lng);
        setCountry(event.target.country);
        setCurrentLocationStatus(true);
      }
    }
  };

  useEffect(() => {
    const driverUnassigned = checkDriverUnassignStatus(
      loadDetails,
      userDetails
    );

    if (open && driverUnassigned) {
      updateShowUnassignedMessage(driverUnassigned);
    }
  }, [loadDetails]);

  useEffect(() => {
    setActualStart(startTripModel.getCurrentTimeInISO());
    setLocationName("");
    setlat("");
    setlng("");
    setCountry("");
    settimezone("");
  }, [props.loadDetails?.shipmentId]);

  let _startDate: string = ActualStart;
  _startDate = startTripModel.getTimeForIOS(_startDate);

  const onConfirm = () => {
    onConfirmStart();
  };

  const [showError, onEmptyError] = useState<boolean>(false);
  useEffect(() => {
    if (locationName && showError) {
      onEmptyError(false);
    }
  }, [locationName]);

  const onConfirmStart = () => {
    if (!locationName || !ActualStart || originError) {
      onEmptyError(true);
      return;
    }

    const _model: InTransitModel = new InTransitModel();
    const location = locationName ? locationName.split(",") : [];
    if (location.length === 1) {
      location.push("");
    }
    const callBack = (shipment: any) => {
      refreshShipmentInDriverLoads(shipment);
    };
    const _startDate: string = ActualStart
    ? dayjs().tz(ActualStart.substring(0, 19)).format()
    : ActualStart;
    dispatch(
      confirmStartInformation(
        _model.confirmStart({
          carrierId: userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          carrierPro: "",
          carrierScac: "",
          city: location[0],
          country,
          latitude: lat ? lat.toString() : "",
          longitude: lng ? lng.toString() : "",
          positionDateTime: _startDate,
          shipmentId: loadDetails.shipmentId,
          sourceSystem: loadDetails.sourceTMS,
          startDateTime: _startDate,
          state: location[1],
          timeZone: timezone,
          userId:userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
          gpsTrackingStatus: EGPSTrackingStatus.GPS_TRACKING_STARTED
        }),
        callBack
      )
    );

    onDismiss();
  };

  const refreshShipmentInDriverLoads = (shipment: any) => {
    const shipmentId: string = shipment && shipment.shipmentId;
    if (!shipmentId) {
      return;
    }

    let driverLoad: any[] = props.loadData.driverLoad.filter(
      (item: any) => item.shipmentId !== shipmentId
    );

    driverLoad = driverLoad.concat({ ...shipment });
    dispatch(loadAssignedData(driverLoad, driverLoad.length));
    const __nav: { [key: string]: string } = {};
    __nav[MY_LOAD] = `/app/myLoad/Execution/${shipmentId}`;
    dispatch(setNavigation(__nav));

    history.push(`/app/myLoad/Execution/${shipmentId}`, {
      module: MODULES.DRIVER_ASSIGNED_MODULE,
    });
  };

  return (
    <React.Fragment>
      <Alert
        isOpen={showUnassignedMessage}
        message={i18n.t("unassignedDriverUpdate")}
        backdropDismiss={false}
        mode="ios"
        cssClass="unAssign-alert-web"
        buttons={[
          {
            text: i18n.t("Ok_TEXT"),
            role: ALERT_BUTTON_ROLES.ok,
            handler: () => {
              updateShowUnassignedMessage(false);
              dispatch(
                removeDriverUnassignedLoad(loadDetails.shipment.shipmentId)
              );
              history.push("/app/MyLoad/DriverAssigned");
            },
          },
        ]}
      />
      <IonModal
        isOpen={open}
        backdropDismiss={false}
        cssClass="confirm-start-trip"
      >
        <IonGrid className="confirm-start-trip-grid">
          <IonRow>
            <IonCol size="12">
              <h3>Confirm Start Time:</h3>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="4" className="confirm-location-col">
              <IonLabel className="actual-start">Enter Start Location</IonLabel>
              <NewInput
                onTimeZoneChange={(timezone: string) => {
                  settimezone(timezone);
                }}
                Error={showError}
                labelValue=""
                InputValue={locationName}
                InputName="locationName"
                handleChange={handleChangeEvent}
                isDestination={false}
                deFaultValue={locationName}
                useHandler={false}
                setErrorValue={setErrorValue}
                locationValue={true}
                placeholder="Enter City Name"
              />
            </IonCol>
            <IonCol size="4" className="cnf-date-col">
              <IonImg
                className="cnf-date-icon"
                src="assets/icon/Calendar.svg"
              />
              <IonLabel className="actual-start">Actual</IonLabel>
              <DatePicker
                onChange={(e: Date) => {
                  let value = e === null ? dayjs().format().toString() : dayjs(e).format().toString();
                  setActualStart(startTripModel.getRoundOffTime(value));
                }}
                dateFormat="MMM d, yyyy hh:mm aa"
                className="actual-start-date-time"
                showTimeSelect
                timeIntervals={5}
                selected={(_startDate && new Date(_startDate)) || null}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <div className="load-stops-grid">
                <IonGrid className="confirm-dialog-load-grid">
                  <IonRow>
                    <IonCol size="3.5">
                      <ShipmentDetails
                        {...loadDetails}
                        showLoadNo={true}
                        isCarrierLoad={true}
                      />
                    </IonCol>
                    <IonCol size="4.5">
                      <LoadStop
                        loadStops={loadStopsToShow}
                        calculateTime={props.calculateTime}
                      />
                    </IonCol>
                    <IonCol size="4" className="cnf-driver-persona-col">
                      <Persona showName={true} name={driverName} />
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" className="action-col">
              <IonButton
                className="btn-cancel"
                onClick={() => {
                  onDismiss();
                }}
              >
                Cancel
              </IonButton>
              &nbsp;&nbsp;
              <IonButton className="btn-confirm" onClick={onConfirm}>
                Confirm
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonModal>
    </React.Fragment>
  );
};
